
/**
 * @name Courtesies.js
 * @author Fellipe Orsini
 * @package clinic-mvp\app\assets\js\Courtesies.js
 */

//import { apiCall, getBaseDir } from './utils.js';

import TableBuilder from '../../table_builder.js';
var getBaseDir = null, apiCall = null, getBranchNameFromId = null, getSecUsers = null, getCourtesyType = null, getCourtesyIsUsed = null, userHasRole = null;

$(function () {
    import('../../utils.js').then(utils => {
        getBaseDir = utils.getBaseDir;
        apiCall = utils.apiCall;
        getBranchNameFromId = utils.getBranchNameFromId;
        getSecUsers = utils.getSecUsers;
        getCourtesyType = utils.getCourtesyType;
        getCourtesyIsUsed = utils.getCourtesyIsUsed;
        userHasRole = utils.userHasRole;

        if (!utils.isUserLoggedIn())
            return;

        // A partir dessa parte só vai executar os códigos abaixo quando estiver na página inicial
        if (location.pathname !== utils.getBaseDir() + 'financeiro/cortesias')
            return;

        new FinancialCourtesies(true, {
            getBaseDir: utils.getBaseDir,
            apiCall: utils.apiCall,
        });
    });
});

class FinancialCourtesies {
    constructor(onloadList = false, deps = {}) {

        this.deps = deps;
        this.operatorAllowedServices = [];
        let self = this;
        this.tableHandler = new TableBuilder({
            table: '#table-courtesies-list',
            tableBody: '.js-courtesies-registrations-table',
            data: [],
            rowsPerPage: parseInt($('.js-courtesies-per-page option:selected').val()),
            filter: false,
            maxPages: 0,
            customId: "CrudCourtesiesHandler",
            tableRowRenderer: function (rowData) {
                return self.mountTableRow(rowData);
            },
            OnClickFirstPage: function () {
                self.fetchCourtesiesList();
            },
            OnClickLastPage: function () {
                self.fetchCourtesiesList();
            },
        });

        getSecUsers(users => {
            console.log('users', users);
            let html = '<option value="" selected disabled>-- Selecione --</option>';
            users.forEach(user => {
                html += `<option value="${user.LOGIN}">${user.LOGIN}</option>`;
            });
            $('.js-courtesies-registrations-requester').html(html);
            $('select[name="courtesy_edit_requester"]').html(html);
        });

        apiCall({
            method: 'GET',
            endpoint: 'api/v1/employee/services',
            successCallback: function (res) {
                console.log('Courtesies.js/employee/services', 'onLoad', res);

                if (res.error) {

                } else {
                    self.operatorAllowedServices = res.data;
                    let html = '<option selected default value="">-- Selecione uma opção --</option>';
                    for (let i in res.data) {
                        let serviceObj = res.data[i];
                        if (serviceObj.SERVICO.toLowerCase().indexOf('cortesia') == -1 && (userHasRole('MANAGER') || userHasRole('COMMERCIAL_ASSISTANT')) && userHasBranch(14))
                            continue;
                        html += `
                            <option value="${serviceObj.ID}" data-service-time="${serviceObj.TEMPO_MINIMO}" data-info='${JSON.stringify(serviceObj)}'>${serviceObj.SERVICO}</option>
                        `;
                    }
                }
            },
            errorCallback(err) {
                console.error('ERROR', 'Courtesies.js/employee/services', 'onLoad', err);
            }
        });

        this.fetchCourtesiesList();
        this.bindDomTableAndFilterEvents();
        this.bindDomEvents();
    }

    fetchCourtesiesList() {
        let self = this;
        $(".js-courtesies-registrations-table").block(window._loader.loading);
        if (this.fetchRequest) {
            if (typeof this.fetchRequest.abort === 'function')
                this.fetchRequest.abort();
            this.fetchRequest = null;
        }
        this.fetchRequest = apiCall({
            method: 'GET',
            endpoint: 'api/v1/courtesies',
            data: {
                search: self.searchQuery,
                page: self.tableHandler.getCurrentPage(),
                recordsPerPage: parseInt($('.js-courtesies-per-page option:selected').val()),
                ...self.selectedBranch !== -1 ? { branchId: self.selectedBranch } : {},
                ...self.startDate !== null && self.endDate !== null ? { startDate: self.startDate, endDate: self.endDate } : {},
                ...self.serviceId !== '' && self.serviceId !== null ? { serviceId: self.serviceId } : {}
            },
            successCallback: function (res) {
                $(".js-courtesies-registrations-table").unblock();
                if (!res.error) {
                    self.courtesiesList = res.data;
                    self.courtesiesTotal = res.total;
                    self.tableHandler.renderPage(self.tableHandler.getCurrentPage(), false, self.courtesiesList, false, self.courtesiesTotal);
                } else {
                    window.toast({
                        error: res.error,
                        text: res.message
                    })
                }
            },
            errorCallback: function (err) {
                $(".modal-edit-patient-dialog").unblock();
            }
        });
    }

    mountTableRow = (courtesy) => {
        let row = `<tr>
            <td>${getBranchNameFromId(courtesy.FILIAL_ID)}</td>
            <td>${getCourtesyType(courtesy.TIPO_CORTESIA)}</td>
            <td>${courtesy.CLIENTE_NOME}</td>
            <td>${courtesy.USUARIO_SOLICITANTE}</td>
            <td>${courtesy.DATA_LIBERACAO}</td>
            <td>${courtesy.OBSERVACAO}</td>
            <td>${getCourtesyIsUsed(courtesy.UTILIZADA)}</td>
            <td>${courtesy.USUARIO}</td>
            <td>${courtesy.TIMEUPD}</td>
            <td>
                <button class="btn btn-sm btn-primary js-edit-courtesy" data-info='${JSON.stringify(courtesy)}'><i class="fas fa-edit"></i></button>
            </td>
        </tr>`;

        return row;
    }

    bindDomTableAndFilterEvents() {
        let self = this;
        // Detecta alteração de página na tabela
        $(document).on('click', `.js-pagination-page-${self.tableHandler.getTableId()}`, function (e) {
            e.preventDefault();
            let pageId = $(this).text();
            self.tableHandler.setCurrentPage(pageId); //console.log('pageId', pageId);
            self.fetchCourtesiesList();
        });
        // Detecta alteração de página na tabela
        $(document).on('click', `.js-pagination-previous-page-${self.tableHandler.getTableId()}`, function (e) {
            e.preventDefault();
            let pageId = self.tableHandler.getCurrentPage() - 1; //console.log('previous pageId', pageId);
            if (pageId <= 0)
                return;
            self.tableHandler.setCurrentPage(pageId); //console.log('pageId', pageId);
            self.fetchCourtesiesList();
        });
        // Detecta alteração de página na tabela
        $(document).on('click', `.js-pagination-next-page-${self.tableHandler.getTableId()}`, function (e) {
            e.preventDefault();
            let pageId = self.tableHandler.getCurrentPage() + 1; //console.log('next pageId', pageId);
            if (pageId > self.tableHandler.getMaxPages())
                return;
            self.tableHandler.setCurrentPage(pageId); //console.log('pageId', pageId);
            self.fetchCourtesiesList();
        });

        // Detecta usuário mudando de filial para buscar paciente
        $('.js-courtesies-registrations-branches-selector').change(function () {
            self.selectedBranch = $(this).val();
            // Caso tenha selecinado uma filial, mostra o campo para buscar pelo nome do paciente
            if (self.selectedBranch != '') {
                self.fetchCourtesiesList();
            } else {
                self.selectedBranch = -1;
            }
        });

        $('#courtesy_create_branch').change(function () {
            self.selectedBranch = $(this).val();
        });

        $('#courtesy_edit_branch').change(function () {
            self.selectedBranch = $(this).val();
        });

        // Detecta usuário buscando pelo nome do paciente
        $('#js-courtesies-registrations-search-input').on('input', function () {
            // make a typing debounce
            clearTimeout(self.searchQueryTimeout);
            self.searchQueryTimeout = setTimeout(function () {
                self.searchQuery = $('#js-courtesies-registrations-search-input').val().trim();
                if (self.searchQuery.length > 3) {
                    self.fetchCourtesiesList();
                } else if (self.searchQuery.length == 0) {
                    self.searchQuery = '';
                    self.fetchCourtesiesList();
                }
            }, 500);
        })

        // Detecta usuário configurando filtro de data de adesão
        $(document).on('change', '.js-courtesies-registrations-start-date-input', function (e) {
            self.startDate = $(this).val();
            if (self.startDate === '')
                self.startDate = null;
            self.fetchCourtesiesList();
        });

        // Detecta usuário configurando filtro de data de adesão
        $(document).on('change', '.js-courtesies-registrations-end-date-input', function (e) {
            self.endDate = $(this).val();
            if (self.endDate === '')
                self.endDate = null;
            self.fetchCourtesiesList();
        });

        // Detecta usuário configurando filtro qtd de registros por página
        $(document).on('change', '.js-courtesies-per-page', function () {
            self.tableHandler.setRowsPerPage(parseInt($(this).val()));
            self.tableHandler.setCurrentPage(1);
            self.fetchCourtesiesList();
        });
    }

    bindDomEvents() {
        let self = this;
        // Detecta usuário clicando no botão de editar paciente
        $(document).on('click', '.js-edit-courtesy', function (e) {
            e.preventDefault();
            let courtesyData = $(this).data('info');
            self.editCourtesy(courtesyData);
        });

        // Detecta usuário clicando no botão de criar novo paciente
        $(document).on('submit', '.js-courtesy-create-form', function (e) {
            e.preventDefault();
            self.createCourtesy();
        });

        $(document).on('submit', '.js-courtesy-edit-form', function (e) {
            e.preventDefault();
            self.updateCourtesy();
        });

        $('#courtesy_create_customer').select2({
            placeholder: "Busque por telefone, nome ou email",
            theme: 'bootstrap-5',
            minimumInputLength: 3,
            dropdownParent: $("#modal-courtesy-create"),
            ajax: {
                url: getBaseDir() + 'api/v1/patient/search',
                delay: 1000,
                data: function (params) {
                    var query = {
                        search: params.term,
                        branchId: self.selectedBranch || -1,
                        page: params.page || 1,
                        allContracts: true
                    }
                    // Query parameters will be ?search=[term]&page=[page]
                    return query;
                },
                processResults: function (data, params) {
                    params.page = params.page || 1;

                    var results = [];
                    $.each(data.results, function (k, v) {
                        results.push({
                            id: v.ID,
                            text: `${v.ID} - ${v.TEXT} - ${v.CADASTRO_COMPLETO == 'N' ? 'Sem CPF' : v.CPF}${v.CONTRATO_ID != null ? ` - C${v.CONTRATO_ID} (${v.SESSOES_REALIZADAS}/${v.TOTAL_SESSOES})` : ' - Sem Contrato'}`,
                            info: v
                        });
                    });

                    // Transforms the top-level key of the response object from 'items' to 'results'
                    return {
                        results: results,
                        pagination: {
                            more: (params.page * 10) < data.count_filtered
                        }
                    };
                }
            }
        });

        $('#courtesy_create_customer').on('select2:select', function (e) {
            $("#courtesy_create_customer_id").val(e.params.data.info.ID);
        });

        $('#courtesy_edit_customer').select2({
            placeholder: "Busque por telefone, nome ou email",
            theme: 'bootstrap-5',
            minimumInputLength: 3,
            dropdownParent: $("#modal-courtesy-edit"),
            ajax: {
                url: getBaseDir() + 'api/v1/patient/search',
                delay: 1000,
                data: function (params) {
                    var query = {
                        search: params.term,
                        branchId: self.selectedBranch || -1,
                        page: params.page || 1,
                        allContracts: true
                    }
                    // Query parameters will be ?search=[term]&page=[page]
                    return query;
                },
                processResults: function (data, params) {
                    params.page = params.page || 1;

                    var results = [];
                    $.each(data.results, function (k, v) {
                        results.push({
                            id: v.ID,
                            text: `${v.ID} - ${v.TEXT} - ${v.CADASTRO_COMPLETO == 'N' ? 'Sem CPF' : v.CPF}${v.CONTRATO_ID != null ? ` - C${v.CONTRATO_ID} (${v.SESSOES_REALIZADAS}/${v.TOTAL_SESSOES})` : ' - Sem Contrato'}`,
                            info: v
                        });
                    });

                    // Transforms the top-level key of the response object from 'items' to 'results'
                    return {
                        results: results,
                        pagination: {
                            more: (params.page * 10) < data.count_filtered
                        }
                    };
                }
            }
        });

        $('#courtesy_edit_customer').on('select2:select', function (e) {
            $("#courtesy_edit_customer_id").val(e.params.data.info.ID);
        });

        $(document).on('click', '.js-courtesy-create-clear', function () {
            $("#courtesy_create_customer_id").val('');
            $('#courtesy_create_customer').val(null).trigger('change');
        });

        $(document).on('click', '.js-courtesy-edit-clear', function () {
            $("#courtesy_edit_customer_id").val('');
            $('#courtesy_edit_customer').val(null).trigger('change');
        });

        this.bindCourtesyIndividualSessionOrPlan('create');
        this.bindCourtesyIndividualSessionOrPlan('edit');
    }

    bindCourtesyIndividualSessionOrPlan(type = 'create') {
        let self = this;
        $(document).on('click', 'input[name="courtesy_' + type + '_is_individual_session_or_courtesy"]', function () {
            $('.js-courtesy-' + type + '-business-services-or-plans-selector').html('');
            if ($(this).val() == 'S') {
                let html = '<option selected default value="">-- Selecione uma opção --</option>';
                for (let i in self.operatorAllowedServices) {
                    let serviceObj = self.operatorAllowedServices[i];
                    if (serviceObj.SERVICO.toLowerCase().indexOf('cortesia') == -1)
                        continue;
                    let isSelected = false;
                    if (self.courtesyServiceIdOrPlanId == serviceObj.ID) {
                        self.courtesyServiceIdOrPlanId = null;
                        isSelected = true;
                    }
                    html += `
                        <option value="${serviceObj.ID}" data-service-time="${serviceObj.TEMPO_MINIMO}" data-info='${JSON.stringify(serviceObj)}' ${isSelected ? 'selected' : ''}>${serviceObj.SERVICO}</option>
                    `;
                }
                $('.js-courtesy-' + type + '-business-services-or-plans-selector').html(html);
            } else {
                // Resgata lista de planos
                if (!self.businessPlans) {
                    apiCall({
                        method: 'GET',
                        endpoint: 'api/v1/business/plans',
                        successCallback: function (res) {
                            if (!res.error) {
                                self.businessPlans = res.data;
                                let html = '<option selected default value="">-- Selecione --</option>';
                                for (let i = 0; i < res.data.length; i++) {
                                    let plan = res.data[i];
                                    if (plan.VISIVEL == 0 || plan.TOTAL_PLANO > 1) continue;
                                    let isSelected = false;
                                    if (self.courtesyServiceIdOrPlanId == plan.ID) {
                                        self.courtesyServiceIdOrPlanId = null;
                                        isSelected = true;
                                    }
                                    html += `<option value='${plan.ID}' data-plan-info='${JSON.stringify(plan)}' ${isSelected ? 'selected' : ''}>${plan.DESCRICAO}</option>`;
                                }
                                $('.js-courtesy-' + type + '-business-services-or-plans-selector').html(html);
                            }
                        },
                        errorCallback: function (err) {
                        }
                    });
                } else {
                    let html = '<option selected default value="">-- Selecione --</option>';
                    for (let i = 0; i < self.businessPlans.length; i++) {
                        let plan = self.businessPlans[i];
                        if (plan.VISIVEL == 0 || plan.TOTAL_PLANO > 1) continue;
                        let isSelected = false;
                        if (self.courtesyServiceIdOrPlanId == plan.ID) {
                            self.courtesyServiceIdOrPlanId = null;
                            isSelected = true;
                        }
                        html += `<option value='${plan.ID}' data-plan-info='${JSON.stringify(plan)}' ${isSelected ? 'selected' : ''}>${plan.DESCRICAO}</option>`;
                    }
                    $('.js-courtesy-' + type + '-business-services-or-plans-selector').html(html);
                }
            }
        });
    }

    createCourtesy() {
        let data = $('.js-courtesy-create-form').serializeArray();
        let self = this;

        $(".js-courtesy-create-form").block(window._loader.loading);
        $('.js-courtesy-create-form').find('input[type="submit"]').prop('disabled', true);

        apiCall({
            method: 'POST',
            endpoint: 'api/v1/courtesy/create',
            data: data,
            successCallback: function (res) {
                $('.js-courtesy-create-form').find('input[type="submit"]').prop('disabled', false);
                $(".js-courtesy-create-form").unblock();
                if (!res.error) {
                    window.toast({
                        text: res.message
                    });
                    $('#courtesy_create_customer').val(null).trigger('change');
                    $('#modal-create-courtesy').modal('hide');
                    $('.js-courtesy-create-form').trigger('reset');
                    self.fetchCourtesiesList();
                } else {
                    window.toast({
                        error: res.error,
                        text: res.message
                    })
                }
            },
            errorCallback: function (err) {
                $('.js-courtesy-create-form').find('input[type="submit"]').prop('disabled', false);
                $(".js-courtesy-create-form").unblock();
            }
        });
    }

    updateCourtesy() {
        let self = this;
        let data = $('.js-courtesy-edit-form').serializeArray();

        $(".js-courtesy-edit-form").block(window._loader.loading);
        $('.js-courtesy-edit-form').find('input[type="submit"]').prop('disabled', true);

        apiCall({
            method: 'POST',
            endpoint: 'api/v1/courtesy/update',
            data: data,
            successCallback: function (res) {
                $('.js-courtesy-edit-form').find('input[type="submit"]').prop('disabled', false);
                $(".js-courtesy-edit-form").unblock();
                if (!res.error) {
                    window.toast({
                        text: res.message
                    });
                    $('#courtesy_edit_customer').val(null).trigger('change');
                    $('#modal-courtesy-edit').modal('hide');
                    $('.js-courtesy-edit-form').trigger('reset');
                    self.fetchCourtesiesList();
                } else {
                    window.toast({
                        error: res.error,
                        text: res.message
                    })
                }
            },
            errorCallback: function (err) {
                $('.js-courtesy-edit-form').find('input[type="submit"]').prop('disabled', false);
                $(".js-courtesy-edit-form").unblock();
            }
        });
    }

    editCourtesy(courtesyData) {
        this.courtesyId = courtesyData.ID;
        this.courtesyServiceIdOrPlanId = courtesyData.SERVICO_ID_OU_PLANO_ID;

        $('#courtesy_edit_id').val(this.courtesyId);
        $('#courtesy_edit_branch').val(courtesyData.FILIAL_ID);
        $('#courtesy_edit_customer_id').val(courtesyData.CLIENTE_ID);
        $('#courtesy_edit_customer').val(courtesyData.CLIENTE_ID);
        $('#courtesy_edit_requester').val(courtesyData.USUARIO_SOLICITANTE);
        $('#courtesy_edit_date').val(courtesyData.DATA_LIBERACAO_ORIGINAL);
        $('#courtesy_edit_type').val(courtesyData.TIPO_CORTESIA);
        $('#courtesy_edit_description').val(courtesyData.OBSERVACAO);
        $('#courtesy_edit_used').val(courtesyData.UTILIZADA);
        if (courtesyData.TIPO_CORTESIA == 'C') {
            $('#courtesy_edit_is_individual_session_or_courtesy_yes').prop('checked', true);
        } else {
            $('#courtesy_edit_is_individual_session_or_courtesy_no').prop('checked', true);
        }
        $('input[name="courtesy_edit_is_individual_session_or_courtesy"]').trigger('click');


        let editCustomerSelect = $('#courtesy_edit_customer');
        let option = new Option(courtesyData.CLIENTE_NOME, courtesyData.ID, true, true);
        editCustomerSelect.append(option).trigger('change');
        editCustomerSelect.trigger({
            type: 'select2:select',
            params: {
                data: {
                    info: {
                        ID: courtesyData.CLIENTE_ID,
                        TEXT: courtesyData.CLIENTE_NOME
                    }
                }
            }
        });

        $('#modal-courtesy-edit').modal('show');
    }
}